/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upgrade_Plan_Modal_Warnings_Downgrade_Not_Allowed_TitleInputs */

const es_components_upgrade_plan_modal_warnings_downgrade_not_allowed_title = /** @type {(inputs: Components_Upgrade_Plan_Modal_Warnings_Downgrade_Not_Allowed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Degradación no permitida`)
};

const en_components_upgrade_plan_modal_warnings_downgrade_not_allowed_title = /** @type {(inputs: Components_Upgrade_Plan_Modal_Warnings_Downgrade_Not_Allowed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downgrade Not Allowed`)
};

/**
* | output |
* | --- |
* | "Downgrade Not Allowed" |
*
* @param {Components_Upgrade_Plan_Modal_Warnings_Downgrade_Not_Allowed_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_warnings_downgrade_not_allowed_title = /** @type {((inputs?: Components_Upgrade_Plan_Modal_Warnings_Downgrade_Not_Allowed_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Warnings_Downgrade_Not_Allowed_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_warnings_downgrade_not_allowed_title(inputs)
	return en_components_upgrade_plan_modal_warnings_downgrade_not_allowed_title(inputs)
});
export { components_upgrade_plan_modal_warnings_downgrade_not_allowed_title as "components.upgrade_plan_modal.warnings.downgrade_not_allowed.title" }